import styled from 'styled-components';

export const Icon = styled.img`
  object-fit: contain;
  margin-right: 8px;
`;
